<template lang="pug">
  .container-paymentList.container-padding
    c-header
      template(slot="left")
        h3 收款账户管理
        h6 说明：收款账户用于帮助商家在收款时分清账务，商家可以创建多个收款账户用于您在富力好房、自在社区的不同业务、不同店铺的收款，每笔订单都将记录资金进入到了哪个收款账户。
      template(slot="right")
        el-button(type="primary", @click="showCreate") 添加收款账户
      c-box.container-filters
        el-form(:model="filters",label-position="right",label-width="100px")
          el-row(:gutter="10")
            el-col(:span="8")
              el-form-item(label="收款账户")
                el-input(v-model="filters.keyword")
            el-col(:span="8")
              el-form-item(label="账户 ID")
                el-input(v-model="filters.account_id")
            el-col(:span="8")
              el-form-item(label="")
                el-button(@click="setFilter",type="primary") 搜索
                el-button(@click="clearFilter", v-show="hasFilter") 清除
    br
    c-box.paymentCard-container(v-loading="listLoading", :element-loading-fullscreen="false")
      el-card.paymentCard(v-for="p in list", :key="p.account_id", shadow="hover")
        .paymentCard-title(slot="header") {{ p.desc }}
        .paymentCard-content ID: {{ p.account_id }}
        hr
        .paymentCard-options
          .paymentCard-copy(@click="copyAccountId(p.account_id)")
            fa-icon(:icon="['fa', 'clipboard']")
            span 复制 ID
          template(v-if="p.settle_type === 3")
            .paymentCard-detail(@click="showWalletDetail(p.account_id,p.settle_account)")
              span 详情
              fa-icon(:icon="['fa', 'arrow-alt-circle-right']")
          template(v-else)
            .paymentCard-detail(@click="showDetail(p.account_id)")
              span 详情
              fa-icon(:icon="['fa', 'arrow-alt-circle-right']")
        hr
        .paymentCard-settle-type 结算方式：{{p.settle_type | settle_type_long}}
    .container-pagination
      el-pagination(layout="sizes, prev, pager, next, total",
        :current-page="page", :total="total", :page-size="size", :page-sizes="[5, 10, 15, 20, 25, 50]",
        @size-change="changeListSize", @current-change="getList")

    el-dialog(title="添加收款账户", :visible.sync="createAccount.show", width="40%")
      el-form(:model="createAccount", label-position="right", label-width="150px")
        el-form-item(label="收款账户名称", required)
          el-input(v-model="createAccount.desc")
        el-form-item(label="结算方式", required)
          .txt-tip 结算方式的区别，具体可咨询平台的商务经理
          template(v-for='(item,idx) in walletList')
            el-radio(v-model="createAccount.settle_type",:label="item.id") 富力钱包-{{item.wallet.title}}({{item.wallet.id}})
            br
          .txt-tip.txt-indent-2(v-if="enable_wallet_settle === 1 && walletList.length>1") 资金将转到富力钱包中，商家可自行提现到绑定的银行卡中
            //- el-radio(v-model="createAccount.settle_type", :label="3", v-if="enable_wallet_settle === 1 && open_wallet!==0") 富力钱包（推荐）
            //- .txt-tip.txt-indent-2(v-if="enable_wallet_settle === 1") 资金将转到富力钱包中，商家可自行提现到绑定的银行卡中
          el-radio(v-model="createAccount.settle_type", :label="1") 银行卡结算
          .txt-tip.txt-indent-2 申请结算后，资金将直接转到绑定的银行卡中
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveCreate()",:loading="isRequset") 保存
        el-button(@click="hideCreate()") 取消
</template>

<script>
export default {
  data() {
    return {
      demo: "",
      page: 1,
      size: 20,
      status: 0,
      list: [],
      total: 0,
      open_wallet: 0,
      listLoading: false,

      filters: {
        account_id: null,
        keyword: null
      },
      hasFilter: false,

      createAccount: {
        show: false,
        desc: null,
        settle_type:
          this.$store.getters.mchDetail.enable_wallet_settle === 1 ? 3 : 1
      },
      walletList: [],
      account_limit: 0,
      isRequset: false
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    enable_wallet_settle() {
      // 是否开启富力钱包 1 = 开启，其他 = 禁用
      return this.$store.getters.mchDetail.enable_wallet_settle;
    }
  },
  methods: {
    copyAccountId(content) {
      this.$clipboard(content);
      this.$message({
        type: "success",
        message: "账户 ID 已复制"
      });
    },
    showCreate() {
      if (this.list.length < this.account_limit) {
        this.createAccount = {
          show: true,
          desc: null,
          settle_type:
            this.$store.getters.mchDetail.enable_wallet_settle === 1 ? 3 : 1
        };
      } else {
        this.$message({
          type: "warning",
          message: `您只能最多创建 ${this.account_limit} 个收款账户。`
        });
      }
    },
    hideCreate() {
      this.createAccount = {
        show: false,
        desc: null,
        settle_type:
          this.$store.getters.mchDetail.enable_wallet_settle === 1 ? 3 : 1
      };
    },
    saveCreate() {
      if (!this.createAccount.desc) {
        this.$message({
          type: "warning",
          message: `请输入账户名称。`
        });
        return;
      }
      this.isRequset = true;
      const params = {
        desc: this.createAccount.desc,
        settle_type: this.createAccount.settle_type !== 1 ? 3 : undefined,
        settle_id:
          this.createAccount.settle_type !== 1
            ? this.createAccount.settle_type
            : undefined
      };
      this.$store
        .dispatch("CREATE_ACCOUNT", params)
        .then(({ account_id }) => {
          this.hideCreate();
          this.getList(1);
          this.isRequset = false;
          // this.$message({
          //   type: "success",
          //   message: "收款账户添加成功。稍后将进入账户详情页面……"
          // });

          // const t = setTimeout(() => {
          //   clearTimeout(t);
          //   // if(this.createAccount.settle_type ===3 ){

          //   // }
          //   this.showDetail(account_id);
          // }, 3 * 1000);
        })
        .catch(({ code, msg }) => {
          if (code == 45101) {
            this.$message({
              type: "error",
              message: msg
            });
          } else {
            this.$message({
              type: "error",
              message: `收款账户添加失败。${code}：${msg}`
            });
          }
          this.isRequset = false;
        });
    },

    showDetail(account_id) {
      this.$router.push(`/payment/${account_id}`);
    },

    showWalletDetail(account_id, settle_account) {
      this.$router.push(`/payment/${account_id}/${settle_account}`);
    },

    getAccountLimit() {
      const { uname } = this.userInfo;
      return this.$store
        .dispatch("GET_MCH_DETAIL", uname)
        .then(({ account_limit }) => {
          this.account_limit = account_limit;
          return account_limit;
        })
        .catch(({ code, msg }) => {
          this.$alert(`收款账户数量上限获取失败。${code}：${msg}`, {
            type: "error"
          });
        });
    },

    setFilter() {
      if (this.filters.account_id || this.filters.keyword) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }

      this.getList(1);
    },
    clearFilter() {
      this.filters = {
        account_id: null,
        keyword: null
      };
      this.hasFilter = false;
      this.getList(1);
    },
    refresh() {
      this.getList(this.page);
    },
    changeListSize(size = 20) {
      this.size = size;
      this.getList(1);
    },
    getList(page = 1) {
      if (!this.listLoading) {
        this.page = page;
        this.listLoading = true;
      } else {
        return;
      }

      const _filters = Object.assign({}, this.filters);
      this.$store
        .dispatch(
          "GET_ACCOUNT_LIST",
          Object.assign(
            {
              offset: this.size * (this.page - 1),
              limit: this.size,
              stat: true
            },
            _filters
          )
        )
        .then(data => {
          this.list = data.list;
          this.total = data.total;
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    getWalletList() {
      this.$store
        .dispatch("GET_SETTLE_ACCOUNT_LIST", {
          settle_type: 3,
          //   bind_status: false,
          limit: 150
        })
        .then(data => {
          data.list.forEach(item => {
            if (item.tunnel && item.tunnel.is_sign_contact == 2) {
              this.walletList.push(item);
            }
          });
        })
        .catch(({ msg }) => {
          this.$alert(`${msg}`, {
            type: "error"
          });
        })
        .finally(() => {
          this.listLoading = false;
        });
    }

    // 获取钱包List
    // getWalletList(page = 1) {
    //   this.$store
    //     .dispatch(
    //       "GET_SETTLE_ACCOUNT_LIST",
    //       Object.assign({
    //         offset: this.size * (this.page - 1),
    //         limit: this.size,
    //         stat: true
    //       })
    //     )
    //     .then(data => {
    //       console.log(data);
    //     })
    //     .catch(({ msg }) => {
    //       this.$alert(`${msg}`, {
    //         type: "error"
    //       });
    //     })
    // }
  },
  mounted() {
    this.getAccountLimit();
    this.getList(1);
    this.getWalletList();
    // this.getWalletList(1);
  }
};
</script>

<style lang="less">
@import (reference) "../../assets/general";

.container-paymentList {
  .paymentCard-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .paymentCard {
    box-sizing: border-box;
    width: 23%;
    margin: 10px 1%;

    .el-card__header {
      padding: 10px;
      font-size: 14px;
      font-weight: bold;
      word-break: break-all;
    }
    .el-card__body {
      padding: 10px;
      font-size: 12px;
    }
  }

  .paymentCard-options {
    display: flex;
    align-items: center;
    justify-content: space-between;

    svg + span,
    span + svg {
      margin-left: 0.5em;
    }
  }
  .paymentCard-copy,
  .paymentCard-detail {
    cursor: pointer;
  }

  .txt-indent-2 {
    text-indent: 25px;
  }
}
</style>
